const prefix = process.env.NODE_ENV === 'development' ? 'external-service' : 'external-service';

export const check_account_number = (accountNumber) => `${prefix}/kyc/account?accountNumber=${accountNumber}`;
